import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PasswordConfirmIdentity from 'components/Auth/PasswordConfirmIdentity';
import { clearRequest, selectAPIRequestErrors, selectIsLoadingAPIRequest } from 'store/ApiClient';
import { forgotPasswordRequest, forgotPasswordVerifyRequest, selectForgotPasswordIdentity } from 'store/App';
import * as ActionTypes from 'store/App/types';
import { IStore } from 'store/types';
import { IApiErrorPayloadWithCode, IForgotPasswordPayloadProps } from 'types';
import { formatDateForApi } from 'utils/date';
import { formatIdentityForUI } from 'utils/identity';

interface IPasswordConfirmIdentityProps {
  onBack: () => void;
  onSubmitUrl?: string;
  resendPayload: IForgotPasswordPayloadProps;
}

const PasswordConfirmIdentityScreen: React.FC<IPasswordConfirmIdentityProps> = ({ onBack, onSubmitUrl, resendPayload }) => {
  const dispatch = useDispatch();
  const identity = useSelector(selectForgotPasswordIdentity());
  const identityDisplayValue = identity ? formatIdentityForUI(identity) : '';
  const communicationType = identity?.type;
  const identityId = identity?.id;
  const isLoading = useSelector((state: IStore) => selectIsLoadingAPIRequest(state, ActionTypes.App.FORGOT_PASSWORD_VERIFY_REQUEST));
  const apiErrors = useSelector((state: IStore) => selectAPIRequestErrors(state, ActionTypes.App.FORGOT_PASSWORD_VERIFY_REQUEST)) as IApiErrorPayloadWithCode;
  const isSmsResubmitLoading = useSelector((state: IStore) => selectIsLoadingAPIRequest(state, ActionTypes.App.FORGOT_PASSWORD_REQUEST));

  const onSubmit = (verificationCode: string) => {
    dispatch(forgotPasswordVerifyRequest(identityId, { verifyCode: verificationCode }, onSubmitUrl));
  };

  const resendSms = () => {
    dispatch(forgotPasswordRequest({ ...resendPayload, dateOfBirth: formatDateForApi(resendPayload.dateOfBirth) }, undefined, 'Successfully resent code'));
  };

  const subtitle = communicationType === 'email' ? 'Enter the code sent to your email' : 'Enter the code sent to your mobile number';

  return (
    <PasswordConfirmIdentity
      onClear={() => dispatch(clearRequest(ActionTypes.App.FORGOT_PASSWORD_REQUEST))}
      onSubmit={onSubmit}
      subtitle={subtitle}
      emailOrMobileNumber={identityDisplayValue}
      onBack={onBack}
      isSmsResubmitLoading={isSmsResubmitLoading}
      isLoading={isLoading}
      apiErrors={apiErrors}
      resendSms={resendSms}
    />
  );
};

export default PasswordConfirmIdentityScreen;
